/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RoleListVm,
    RoleListVmFromJSON,
    RoleListVmFromJSONTyped,
    RoleListVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface RoleListVmPaginatedSearchResponse
 */
export interface RoleListVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<RoleListVm>}
     * @memberof RoleListVmPaginatedSearchResponse
     */
    items?: Array<RoleListVm> | null;
    /**
     * 
     * @type {number}
     * @memberof RoleListVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleListVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleListVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleListVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleListVmPaginatedSearchResponse
     */
    size?: number;
}

export function RoleListVmPaginatedSearchResponseFromJSON(json: any): RoleListVmPaginatedSearchResponse {
    return RoleListVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function RoleListVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleListVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(RoleListVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function RoleListVmPaginatedSearchResponseToJSON(value?: RoleListVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(RoleListVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


